import { IApplicationState } from '../../types/redux';
import { pathOr } from 'ramda';
import { IHouseDesktopSchema } from '../../repositories/newbuilding-card/entities/house/HouseDesktopSchema';

export const getEscrowHouses = (state: IApplicationState) => {
  const houses = pathOr([], ['newbuilding', 'housesByName'], state) as IHouseDesktopSchema[];

  return houses.filter(house => house.isEscrow);
};
